var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencilcomponent = function SvgPencilcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 1C5.47 1 1 5.47 1 11s4.47 10 10 10 10-4.47 10-10S16.53 1 11 1Z",
    stroke: "#A08264"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.777 9.224a.746.746 0 0 0 0-1.063l-.938-.938a.746.746 0 0 0-1.063 0l-.72.719c-.062.063-.062.188 0 .266l1.736 1.735c.078.063.203.063.266 0l.72-.719Zm-3.33-.672-4.112 4.112-.329 1.892a.372.372 0 0 0 .438.438l1.892-.329 4.112-4.112c.078-.062.078-.188 0-.266l-1.735-1.735c-.079-.063-.204-.063-.266 0Zm-3.065 5.066h.75v.578l-1.016.172-.484-.485.172-1.016h.578v.75Z",
    fill: "#A08264"
  })));
};
export default SvgPencilcomponent;